import Edit from './IncidentManagementEdit'
import New from './IncidentManagementNew'
import Show from './IncidentManagementShow'

export default {
  Edit,
  New,
  Show,
}
